<template>
  <div class="grid-content">
    <div class="content-image">
      <a
        target="_blank"
        :href="type == 3 ? `/studyDetail/index.html?id=${data.item.id}` :data.item.url"
      >
        <div class="zoom">
          <img
            v-lazy="type == 3 ? data.item.indexImg : type !== 1 ? data.item.picture : data.item.head_photo"
          />
        </div>
      </a>
    </div>
    <div class="content-title">
      <a
        target="_blank"
        :href="type == 3 ? `/studyDetail/index.html?id=${data.item.id}` :data.item.url"
        v-text="data.item.title"
      >物流的定义</a>
    </div>
    <div
      class="content-subtitle"
      :class="{ 'content-subtitle_1': type === 2 }"
      v-text="type == 3 ? data.item.intro : data.item.abstract"
    >物流的概念最早是在美国形成的，起源于20世纪30年代，原意为“实物分配”或“货物配送”。1963中国的“物流”一词是从日文资料引进。1963中国的“物流”一词是从日文资料引进</div>
    <div v-if="type !== 1" class="content-user">
      <div class="user-header">
        <a
          v-if="type == 3 ? data.item.photo : data.item.head_photo"
          :href="type == 3 ? `/user/homepage.html?userId=${data.item.userId}` : data.item.user_url"
          target="_blank"
          :style="{ backgroundImage: 'url(' + (type == 3 ? data.item.photo : data.item.head_photo) + ')' }"
        ></a>
        <a
          v-else
          class="no-img"
          :href="type == 3 ? `/user/homepage.html?userId=${data.item.userId}` : data.item.user_url"
          target="_blank"
        ></a>
      </div>
      <div class="user-name">
        <a
          :href="type == 3 ? `/user/homepage.html?userId=${data.item.userId}` : data.item.user_url"
          target="_blank"
          v-text="data.item.name"
        >Zeplin</a>
      </div>
      <div class="user-icon">
        <i class="iconfont icon-renzheng"></i>
      </div>
    </div>
    <div class="content-info">
      <div class="info-num">
        <i class="iconfont" :class="type === 3 ? 'icon-huaban' : 'icon-biyan'"></i>
        {{type == 3 ? data.item.learnTimes : data.item.click_times }}
      </div>
      <div class="info-score" v-text="String(data.item.score)">4.8</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Lemma",
  props: {
    data: Object,
    type: Number
  }
};
</script>
<style scope lang="scss">
@import "./../../../assets/iconfont/iconfont.css";
.grid-content {
  width: 270px;
  margin: 20px auto;
  .content-image {
    width: 270px;
    height: 170px;
    a {
      height: 100%;
      width: 100%;
      display: block;
      position: relative;
      overflow: hidden;
      .zoom {
        width: auto;
        height: 170px;
        background: #c5d2d9 no-repeat 50%;
        background-size: cover;
        transition: transform 0.4s ease-out;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    a:before {
      content: "";
      position: absolute;
      display: block;
      width: 100%;
      height: 100%;
      top: 0;
      left: 2;
      z-index: 1;
      background-color: transparent;
      -webkit-transition: background 0.3s;
      transition: background 0.3s;
    }
  }
  .content-title {
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    a {
      font-size: 16px;
      line-height: 26px;
      color: #222222;
    }
    a:hover {
      color: #25a257;
    }
  }
  .content-subtitle {
    height: 54px;
    font-size: 12px;
    line-height: 18px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }
  .content-subtitle_1 {
    height: 54px;
    -webkit-line-clamp: 3;
  }
  .content-user {
    width: 100%;
    height: 50px;
    background-color: #f5f5f5;
    border-radius: 5px;
    margin: 0 auto;
    margin-top: 15px;
    box-sizing: border-box;
    padding: 0 15px;
    display: flex;
    align-items: center;
    .user-header {
      width: 40px;
      height: 40px;
      background-color: #ffffff;
      border-radius: 50%;
      overflow: hidden;
      a {
        width: 100%;
        height: 100%;
        display: block;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 50%;
        position: relative;
        z-index: 1;
      }
      .no-img {
        background-image: url("../../../assets/images/header.png");
      }
    }
    .user-name {
      a {
        font-size: 12px;
        line-height: 18px;
        color: #999999;
        margin-left: 15px;
      }
      a:hover {
        color: #25a257;
      }
    }
    .user-icon {
      margin-left: auto;
      .iconfont {
        color: #ff9700 !important;
      }
    }
  }
  .content-info {
    display: flex;
    justify-content: space-between;
    .info-num {
      font-size: 12px;
      line-height: 48px;
      color: #000000;
      .iconfont {
        font-size: 12px;
        line-height: 48px;
        color: rgba(178, 178, 178, 0.3);
        margin-right: 10px;
      }
    }
    .info-score {
      font-size: 16px;
      line-height: 48px;
      color: #ff6000;
    }
  }
}
.grid-content:hover .content-image a:before {
  background-color: rgba(0, 0, 0, 0.1);
}
.grid-content:hover .content-image > a > div {
  transform: scale(1.05);
  transition: transform 0.4s ease-in;
}
</style>
